import { render } from "./TheAdminProfessionalDestroy.vue?vue&type=template&id=26da5d5b&ts=true"
import script from "./TheAdminProfessionalDestroy.vue?vue&type=script&lang=ts"
export * from "./TheAdminProfessionalDestroy.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__